/*
 * @Date: 2022-08-06 14:05:59
 * @LastEditors: sunyuxia
 * @LastEditTime: 2022-08-06 14:24:03
 * @description:
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "./init.js";

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
